<template>
  <div class="ioRecord">
    <div class="right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label>订单号：</label>
            <el-input v-model="search.no" style="width: 120px"> </el-input>
          </div>
          <div class="form-group">
            <label>车牌：</label>
            <el-input v-model="search.plateNumber" style="width: 120px">
            </el-input>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button @click="searchList" type="primary" :loading="loading" size="small">查询</el-button>
            </span>
            <span class="download_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
              >
                导出
              </button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <div v-show="showList" class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
            v-loading="loading"
          >
            <el-table-column
              show-overflow-tooltip
              label="订单号"
              prop="no"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="车牌"
              prop="plateNumber"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="道路"
              prop="parkingName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="金额"
              prop="realPay"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="月数"
              prop="months"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="支付类型"
              prop="payTypeName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="支付时间"
              prop="payTime"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="开始时间"
              prop="startTime"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="结束时间"
              prop="endTime"
            ></el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <Page v-show="showList" v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getRentMonthOrderparking } from "@/api/url";
import Page from "../../commons/page";
export default {
  data() {
    return {
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      groupList: [],
      tableListData: [],
      tableListDataTitle: [],
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        no: "",
        plateNumber: "",
      },
      value4: "",
      pageObj: {},
      loading: false
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      var _this = this;
      this.loading = true;
      this.$get(getRentMonthOrderparking(), {
        page: curPage,
        limit: this.search.pageSize,
        no: this.search.no,
        plateNumber: this.search.plateNumber,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        // _this.getPage(pageObj);
        _this.pageObj={...pageObj}
        _this.tableListData = data.data.rows.map(r=>{
          r.payTypeName=r.payType==='wechat'?'微信支付':(r.payType==='miniProgram'?'微信小程序':'现金')
          return r;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });

    },
    searchList() {
     
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
     
    },
    downloadData() {
      this.$downloadFileRequest(
        "/api/parking/rentMonthOrder/export",
        {
          no: this.search.no,
          plateNumber: this.search.plateNumber,
        },
        "月租车续费记录"
      );
    },
  },
  components: {
    Page,
  },
  mounted: function () {
    this.searchList();
  },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
  width: 16px;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
}
.show-list {
  height: 500px;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.download_btn {
  display: inline-block;
  margin-left: 15px;
}
</style>